import { Field } from 'formik';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';

const FieldItemMaxChars = (props) => {
   const [value, setValue] = useState('');

   return (
      <>
         <Label
            className='d-block'
         >
            { props.label }
            <span className='float-right'>
               {value.length}
               /
               {props.maxCharacters}
            </span>
            <Field
               {
                  ...props
               }
               setValue={setValue}
               maxCharacters={props.maxCharacters}
            />
         </Label>
      </>
   );
};

FieldItemMaxChars.propTypes = {
   label: PropTypes.string.isRequired,
   name: PropTypes.string.isRequired,
   component: PropTypes.func.isRequired,
   maxCharacters: PropTypes.number.isRequired,
   options: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
   })),
};

FieldItemMaxChars.defaultProps = {
   options: undefined,
};


export default FieldItemMaxChars;
